import { Expose, Type } from 'class-transformer';
import { ViewProductDto } from './view-product.dto';
import { ViewCategoryDto } from '../../categories/dto/view-category.dto';

export class ViewProductWithCategoryDto extends ViewProductDto {
  @Expose() @Type(() => ViewCategoryDto) category: ViewCategoryDto;
}
